import axios from 'axios';
import {
  Challenge,
  Play,
  PlayQuestion,
  PlayQuestionAnswer,
  PlayQuestionTimeout,
  PlayShareRequest,
  PlaySummary,
} from '../interfaces/challenge.interface';

export const getChallenges = () => {
  return axios.get<any, Challenge[]>('/frb/challenges');
};

export const getChallenge = (challengeId: string) => {
  return axios.get<any, Challenge>(`/frb/challenges/${challengeId}`);
};

export const startChallengePlay = (challengeId: string) => {
  return axios.post<any, Play>(`/frb/challenges/${challengeId}/start-play`);
};

export const getNextQuestion = (playId: string) => {
  return axios.post<any, PlayQuestion>(`/frb/plays/${playId}/next-question`);
};

export const sendQuestionAnswer = (playId: string, answerId: string) => {
  return axios.post<any, PlayQuestionAnswer>(`/frb/plays/${playId}/question-answer`, {
    answer_id: answerId,
  });
};

export const sendQuestionTimeout = (playId: string) => {
  return axios.post<any, PlayQuestionTimeout>(`/frb/plays/${playId}/question-timeout`);
};

export const getPlaySummary = (playId: string) => {
  return axios.post<any, PlaySummary>(`/frb/plays/${playId}/summary`);
};

export const sharePlay = (playId: string, payload: PlayShareRequest) => {
  return axios.post<any, undefined, PlayShareRequest>(`/frb/plays/${playId}/share`, payload);
};
